import flower2 from 'assets/flowers/flower2.webp';
import './index.scss';

const ForWhomSection = () => {
  return (
    <section className='ForWhom_for-whom'>
      <div className='container'>
        <header>
          <h2>Для кого цей курс:</h2>
          <hr />
          <p>🌿 Для початківців, які хочуть одразу робити все правильно й не «вбивати» рослини через незнання.</p>
          <p>🌿 Для власників рослин, які вже мають досвід, але хочуть зрозуміти, чому рослини жовтіють, в’януть або не ростуть — і навчитися доглядати за ними впевнено.</p>
          <p>🌿 Для тих, хто цінує час, хоче простих і ефективних рішень без годин перегляду відео та читання суперечливої інформації.</p>
          <p>🌿 Для тих, хто хоче структурувати знання, системно підійти до теми озеленення і мати чітке розуміння догляду, підбору рослин та оздоблення простору.</p>
          <p>🌿 Для майбутніх озеленювачів, які мріють перетворити любов до рослин на професію, знайти перших клієнтів і почати заробляти на озелененні житлових і комерційних просторів.</p>
        </header>
        <picture className='ForWhom_section-decor'>
          <img
            alt=''
            data-nimg='1'
            decoding='async'
            height='1666'
            src={flower2}
            srcSet={flower2}
            style={{
              color: 'transparent',
            }}
            width='1316'
          />
        </picture>
      </div>
    </section>
  );
};

export default ForWhomSection;
